'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

type TProps = {
  error: Error & { digest?: string };
};

export default function GlobalError({ error }: TProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <NextError statusCode={0} />
    </>
  );
}
